import { rankingEvalModuleQuery, useModule } from 'system/structure-modules';

export default function RankingEvalCustomRankersScreen() {
    const { CustomRankersScreen } = useModule(rankingEvalModuleQuery);
    return <CustomRankersScreen />;
}
